import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import Layout from "src/components/program/layout/Layout";
import Button from "src/components/app/Button";
import SEO from "src/components/common/SEO";

import supportPrograms from "src/data/app/programs";
import { SCREEN_NAMES } from "src/helpers/analytics/events";
import analytics from "src/helpers/analytics";
import auth from "src/helpers/auth";
// import SampleDoctorImg from "src/assets/images/psp/sample-doctor.png";

const SuccessScreen: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const config =
    supportPrograms[params.support_program_key as keyof typeof supportPrograms];

  useEffect(() => {
    // Event: ONBOARDING_SUCCESS
    analytics.pageView(SCREEN_NAMES.ONBOARDING_SUCCESS_SCREEN);

    // Cleanup function - runs when component unmounts (user leaves the screen)
    return () => {
      (async () => {
        await auth.handleLogout();
      })();
    };
  }, []);

  const handleDownloadApp = () => {
    navigate("/app-links/app-download");
    // navigate("/programs/:support_program_key/onboarding/success");
  };

  const title = `Welcome to your health journey!`;
  const description = `Your profile has been created successfully. Our care specialist will review your information and get in touch with you soon.`;

  return (
    <Layout
      className="bg-white"
      enableTheme={true}
      supportProgramKey={params.support_program_key}
      footer={
        <div className="bg-white border-t border-gray-200 p-4">
          <Button fullWidth onClick={handleDownloadApp}>
            <span className="flex items-center gap-2">
              Download App
              <ArrowRight className="w-4 h-4" />
            </span>
          </Button>
        </div>
      }
      stickyFooter={true}
    >
      <SEO title={title} description={description} />
      <div className="flex flex-col h-full">
        <div className="p-4 flex-1 overflow-y-auto flex flex-col items-center">
          <img
            src={config?.logo_url}
            alt={config?.support_program_name}
            className="h-10 mt-6"
          />

          {/* <img
            src={SampleDoctorImg}
            alt=""
            className="w-24 h-24 rounded-full object-cover"
          /> */}

          <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-2 text-center mt-6">
            {title}
          </h1>
          <p className="text-[var(--text-secondary)] mb-4 text-center">
            {description}
          </p>

          <p className="text-sm text-[var(--text-secondary)] text-center">
            You'll receive a call within 24 hours to discuss support program.
          </p>

          <div className="bg-[var(--bg-secondary)] rounded-lg p-4 space-y-3 mt-4">
            <h3 className="font-medium text-[var(--text-primary)] text-center">
              What happens next?
            </h3>
            <div className="space-y-2 text-sm text-[var(--text-secondary)]">
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-[var(--app-primary)] rounded-full"></span>
                <span>Care specialist will review your profile</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-[var(--app-primary)] rounded-full"></span>
                <span>Personalized support program will be created</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-[var(--app-primary)] rounded-full"></span>
                <span>You'll receive a welcome call</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SuccessScreen;
